const enquiredData = (xmlElement) => {
    const EnquiredData = xmlElement.getElementsByTagName("cb:EnquiredData")[0];
    const SubjectRefDate = EnquiredData?.attributes.SubjectRefDate?.value ?? '';
    const Gender = EnquiredData?.getElementsByTagName("cb:Individual")[0].attributes.Gender?.value ?? ''
    const GenderDesc = EnquiredData?.getElementsByTagName("cb:Individual")[0].attributes.GenderDesc?.value ?? ''
    const NameAsId = EnquiredData?.getElementsByTagName("cb:IndividualName")[0].attributes.NameAsId?.value ?? ''
    const FullName = EnquiredData?.getElementsByTagName("cb:IndividualName")[0].attributes.FullName?.value ?? ''
    const MothersName = EnquiredData?.getElementsByTagName("cb:IndividualName")[0].attributes.MothersName?.value ?? ''
    const BirthDate = EnquiredData?.getElementsByTagName("cb:BirthData")[0].attributes.Date?.value ?? ''
    const BirtPlace = EnquiredData?.getElementsByTagName("cb:BirthData")[0].attributes.Place?.value ?? ''
    const MarriageStatus = EnquiredData?.getElementsByTagName("cb:Individual")[0].attributes.MarriageStatus?.value ?? ''
    const MarriageStatusDesc = EnquiredData?.getElementsByTagName("cb:Individual")[0].attributes.MarriageStatusDesc?.value ?? ''
    const EducationalStatusCode = EnquiredData?.getElementsByTagName("cb:Individual")[0].attributes.EducationalStatusCode?.value ?? ''
    const EducationalStatusCodeDesc = EnquiredData?.getElementsByTagName("cb:Individual")[0].attributes.EducationalStatusCodeDesc?.value ?? ''
    const Address = EnquiredData?.getElementsByTagName("cb:Address")[0].firstElementChild.attributes.Address?.value ?? ''
    const SubDistrict = EnquiredData?.getElementsByTagName("cb:Address")[0].firstElementChild.attributes.SubDistrict?.value ?? ''
    const District = EnquiredData?.getElementsByTagName("cb:Address")[0].firstElementChild.attributes.District?.value ?? ''
    const City = EnquiredData?.getElementsByTagName("cb:Address")[0].firstElementChild.attributes.City?.value ?? ''
    const PostalCode = EnquiredData?.getElementsByTagName("cb:Address")[0].firstElementChild.attributes.PostalCode?.value ?? ''
    const Country = EnquiredData?.getElementsByTagName("cb:Address")[0].firstElementChild.attributes.Country?.value ?? ''
    const CityDesc = EnquiredData?.getElementsByTagName("cb:AddressDesc")[0].attributes.CityDesc?.value ?? '-'
    const CountryDesc = EnquiredData?.getElementsByTagName("cb:AddressDesc")[0].attributes.CountryDesc?.value ?? ''
    const IdentityType = EnquiredData?.getElementsByTagName("cb:IdentificationCode")[0].firstElementChild.attributes.IdentityType?.value ?? ''
    const IdentityTypeDesc = EnquiredData?.getElementsByTagName("cb:IdentificationCodeDesc")[0].attributes.IdentityTypeDesc?.value ?? ''
    const IdentityNumber = EnquiredData?.getElementsByTagName("cb:IdentificationCode")[0].firstElementChild.attributes.IdentityNumber?.value ?? ''
    const NPWP = EnquiredData?.getElementsByTagName("cb:ID")[0].attributes.NPWP?.value ?? '';
    const PhoneNumber = EnquiredData?.getElementsByTagName("cb:Contact")[0].attributes.PhoneNumber?.value ?? ''
    const CellphoneNumber = EnquiredData?.getElementsByTagName("cb:Contact")[0].attributes.CellphoneNumber?.value ?? ''
    const EmailAddress = EnquiredData?.getElementsByTagName("cb:Contact")[0].attributes.EmailAddress?.value ?? ''

    const results = {
        SubjectRefDate,
        Gender,
        GenderDesc,
        NameAsId,
        FullName,
        MothersName,
        BirthDate,
        BirtPlace,
        MarriageStatus,
        MarriageStatusDesc,
        EducationalStatusCode,
        EducationalStatusCodeDesc,
        Address,
        SubDistrict,
        District,
        City,
        PostalCode,
        Country,
        CityDesc,
        CountryDesc,
        IdentityType,
        IdentityTypeDesc,
        IdentityNumber,
        NPWP,
        PhoneNumber,
        CellphoneNumber,
        EmailAddress,
    }
    return results;
}

export default enquiredData;
